<template>
  <v-container>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-row>
      <v-col>
        <customer-table
          @toParent="itemFromTable($event)"
          @closeDialog="closeDialog"
          @renderCustomerForm="tab = null"
        />
      </v-col>
    </v-row>
    <v-dialog
      v-model="customer.editCustomer"
      max-width="980"
      scrollable
      transition="dialog-bottom-transition"
      overlay-opacity="0.6"
    >
      <v-card
        elevation="16"
        rounded="lg"
      >
        <v-toolbar
          flat
          dense
          color="color_green"
          dark
        >
          <v-toolbar-title>
            Customer
            <span
              v-if="item_form && item_form.crm_id"
              class="text-caption ml-2"
            >
              ({{ item_form.crm_id }})
            </span>
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            @click="closeEdit"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-tabs
          v-model="tab"
          background-color="color_green"
          slider-color="#00802d"
          slider-size="4"
          show-arrows
          grow
          dark
          @change="loadData()"
        >
          <v-tab>
            Customer Data
          </v-tab>
          <v-tab :disabled="disableTab">
            Api Users
          </v-tab>

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card flat class="pa-2">
                <customer-form
                  :key="componentKey"
                  @closeDialog="closeDialog"
                  @customResetForm="customResetForm"
                  @toParent="itemFromTable($event)"
                />
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat class="pa-2">
                <tech-user-table
                  @closeDialog="closeDialog"
                  @selection-changed="onTechUserSelectionChanged"
                />
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    CustomerTable: () => import('@/components/customer/CustomerTable'),
    CustomerForm: () => import('@/components/customer/CustomerForm'),
    TechUserTable: () => import('@/components/customer/tech-user/TechUserTable')
  },

  data() {
    return {
      tab: null,
      item_form: {
        crm_id: '',
        ragione_sociale: '',
        c_description: ''
      },
      selectedTechUserUsername: '',
      componentKey: 0,
      overlay: false,
      renderDefaultService: false,
      renderCustomerLayers: false,
      renderProfilingHierarchy: false,
      renderAppUserPolicies: false
    };
  },
  computed: {
    ...mapState([
      'customer',
      'disableTab',
      'disableHierarchyTab',
      'policy',
      'services',
      'ticketing',
      'layers'
    ])
  },
  beforeDestroy() {
    if (this.customer.editCustomer == true) {
      this.changeEditCustomer();
    }

    this.$store.state.disableTab = true;
  },

  methods: {
    ...mapActions([
      'changeEditCustomer',
      'changeLinkService',
      'storeCustomerCRMID',
      'storeTechUsers',
      'storeCRMID'
    ]),
    closeDialog() {
      this.tab = null;
      this.closeEdit();
    },
    onTechUserSelectionChanged(selected) {
      this.selectedTechUserUsername =
        Array.isArray(selected) && selected.length > 0
          ? selected[0].username
          : '';
    },
    customResetForm() {
      if (this.customer.isModifingCustomer) {
        this.item_form.ragione_sociale = '';
        this.item_form.c_description = '';
      } else {
        this.item_form.crm_id = '';
        this.item_form.ragione_sociale = '';
        this.item_form.c_description = '';
      }
    },
    itemFromTable(item) {
      this.item_form = JSON.parse(JSON.stringify(item));
      this.renderCustomerLayers = false;
      this.$nextTick(() => {
        this.renderCustomerLayers = true;
      });
      this.customer.crm_id = this.item_form.crm_id;
      this.storeCustomerCRMID(this.item_form);
      this.changeEditCustomer(true);
      this.changeLinkService(true);
      this.forceRerender();
    },
    closeEdit() {
      this.changeEditCustomer(false);
      this.changeLinkService(false);
      this.customer.isModifingCustomer = false;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    async loadData() {
      switch (this.tab) {
        case 0:
          this.overlay = true;
          await this.storeCustomerCRMID(this.item_form);
          await this.storeCRMID(this.item_form.crm_id);
          this.overlay = false;
          break;
        case 1:
          this.overlay = true;
          await this.storeTechUsers(this.item_form.crm_id);
          this.overlay = false;
          break;
        default:
          break;
      }
    }
  }
};
</script>
